import FlourishDeck from "./FlourishDeck";

const FlourishPrint = () => <FlourishDeck autoPrint />;

export default FlourishPrint;
